module.exports = __webpack_public_path__ + "static/media/firebase-database.71c607e4.svg";